module.exports = __webpack_public_path__ + "view/img/lianxis.b5f80e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lianxis.jpg
// module id = 9uKT
// module chunks = 1